import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '../brand';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function Cumplimiento() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white" data-testid="cumplimiento-page">
      {/* Header */}
      <div className="bg-gradient-to-r from-emerald-700 to-teal-700 text-white py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="text-white/80 text-sm hover:text-white mb-4 inline-block">
            ← Volver a inicio
          </Link>
          <h1 className="text-4xl sm:text-5xl font-bold mb-3" data-testid="cumplimiento-title">
            🛡️ Cumplimiento Regulatorio
          </h1>
          <p className="text-lg text-emerald-100 max-w-2xl">
            {BRAND.name} opera bajo estricto cumplimiento de la legislación chilena.
            Somos Sujeto Obligado ante la Unidad de Análisis Financiero (UAF).
          </p>
        </div>
      </div>

      {/* Empresa */}
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-6 shadow-sm">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Empresa</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
            {BRAND.legalName && (
            <div>
              <div className="text-xs text-gray-500 uppercase font-semibold mb-1">Razón Social</div>
              <div className="font-bold text-gray-900">{BRAND.legalName.toUpperCase()}</div>
            </div>
            )}
            {BRAND.legalRut && (
            <div>
              <div className="text-xs text-gray-500 uppercase font-semibold mb-1">RUT</div>
              <div className="font-bold text-gray-900">{BRAND.legalRut}</div>
            </div>
            )}
            <div>
              <div className="text-xs text-gray-500 uppercase font-semibold mb-1">Giro</div>
              <div className="font-bold text-gray-900">Intermediación monetaria y transferencia de dinero</div>
            </div>
            <div>
              <div className="text-xs text-gray-500 uppercase font-semibold mb-1">Marca comercial</div>
              <div className="font-bold text-gray-900">{BRAND.name}</div>
            </div>
          </div>
        </div>

        {/* Marco legal */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-6 shadow-sm">
          <h2 className="text-xl font-bold text-gray-900 mb-3">Marco legal</h2>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex gap-2"><span className="text-emerald-600 font-bold">✓</span> <span><strong>Ley N° 19.913</strong> — Creación de la UAF y delitos LA/FT/FP</span></li>
            <li className="flex gap-2"><span className="text-emerald-600 font-bold">✓</span> <span><strong>Circular UAF N° 49</strong> — Enfoque Basado en Riesgo (EBR)</span></li>
            <li className="flex gap-2"><span className="text-emerald-600 font-bold">✓</span> <span><strong>Circular UAF N° 57</strong> — Personas Expuestas Políticamente (PEP)</span></li>
            <li className="flex gap-2"><span className="text-emerald-600 font-bold">✓</span> <span><strong>Circular UAF N° 62/2025</strong> — Reportes obligatorios para empresas de transferencia de dinero</span></li>
            <li className="flex gap-2"><span className="text-emerald-600 font-bold">✓</span> <span><strong>Ley N° 19.628</strong> — Protección de Datos Personales</span></li>
          </ul>
        </div>

        {/* Controles implementados */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-6 shadow-sm">
          <h2 className="text-xl font-bold text-gray-900 mb-3">Controles implementados</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            {[
              { icon: '🔍', t: 'KYC con IA', d: 'OCR, liveness y face match automatizado con Google Gemini' },
              { icon: '🛂', t: 'Screening OFAC/ONU', d: 'Cruce automático con listas de sanciones internacionales' },
              { icon: '📊', t: 'Matriz de Riesgo EBR', d: '7 factores ponderados clasifican a cada cliente Bajo/Medio/Alto' },
              { icon: '👤', t: 'Gestión PEP', d: 'Identificación de Personas Expuestas Políticamente y su círculo cercano' },
              { icon: '🚨', t: 'Reporte ROS', d: 'Detección y reporte de operaciones sospechosas a la UAF' },
              { icon: '💵', t: 'Reporte ROE', d: 'Reporte obligatorio de operaciones en efectivo ≥ USD 10.000' },
              { icon: '📋', t: 'Boletas DTE 39', d: 'Emisión automática de boletas electrónicas con timbre SII' },
              { icon: '🔐', t: 'Conservación 5 años', d: 'Todos los registros se conservan según Ley 19.913' },
            ].map((c) => (
              <div key={c.t} className="border border-gray-200 rounded-xl p-3">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">{c.icon}</span>
                  <span className="font-bold text-gray-900 text-sm">{c.t}</span>
                </div>
                <p className="text-xs text-gray-600">{c.d}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Documento descargable */}
        <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-2xl p-6 mb-6 shadow-sm">
          <div className="flex items-start gap-4">
            <div className="text-4xl">📘</div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-gray-900">Manual de Prevención LA/FT/FP</h2>
              <p className="text-sm text-gray-700 mt-1 mb-3">
                Manual completo de Prevención de Lavado de Activos, Financiamiento del Terrorismo
                y Financiamiento de la Proliferación de Armas de Destrucción Masiva, versión V01,
                Junio 2026.
              </p>
              <a
                href={`${API_BASE}/api/downloads/manual-plaft-pdf`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-bold rounded-xl shadow-sm transition"
                data-testid="manual-plaft-download-btn"
              >
                📥 Descargar Manual PDF
              </a>
            </div>
          </div>
        </div>

        {/* Canal de denuncias */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-6 shadow-sm">
          <h2 className="text-xl font-bold text-gray-900 mb-3">Canal de denuncias</h2>
          <p className="text-sm text-gray-700 mb-3">
            Si detecta cualquier operación sospechosa o tiene información relevante para nuestro
            cumplimiento PLAFT, puede contactar directamente a nuestro Oficial de Cumplimiento.
            Garantizamos confidencialidad absoluta.
          </p>
          <div className="bg-gray-50 rounded-xl p-4 text-sm space-y-1">
            <div><strong>Email Oficial de Cumplimiento:</strong> <a href={`mailto:${BRAND.complianceEmail}`} className="text-emerald-700 underline">{BRAND.complianceEmail}</a></div>
            <div><strong>WhatsApp / Soporte:</strong> <a href={`mailto:contacto@${BRAND.domain}`} className="text-emerald-700 underline">contacto@{BRAND.domain}</a></div>
          </div>
        </div>

        <div className="text-center text-xs text-gray-500 py-4">
          {[
            BRAND.name,
            BRAND.legalName ? BRAND.legalName.toUpperCase() : null,
            BRAND.legalRut ? `RUT ${BRAND.legalRut}` : null,
            'Sujeto Obligado UAF Chile',
          ].filter(Boolean).join(' · ')}
        </div>
      </div>
    </div>
  );
}
